export default "__VITE_ASSET__BCv0vOcV__"